import AppLayout from "@/components/layout/AppLayout";
import { EnhancedDashboard } from "@/components/enhanced-dashboard";

const EnhancedDashboardPage = () => {
  return (
    <AppLayout>
      <EnhancedDashboard />
    </AppLayout>
  );
};

export default EnhancedDashboardPage;